import type { ReactNode } from "react";

import type { FuseCurrency } from "@shared/fuse-api";

import type { BaseInputProps } from "../base-input/base-input";

import { useController, useFormContext } from "react-hook-form";

import { BaseInput } from "../base-input";

import styles from "./amount-input.module.css";

type AmountInputProps = Omit<BaseInputProps, "type"> & {
	currency?: FuseCurrency;
	name: string;
};

export function AmountInput({ currency, name, ...props }: AmountInputProps): ReactNode {
	const currencyString: string = currency || "-";
	const { control } = useFormContext();
	const { field, fieldState } = useController({ control, name });

	return (
		<div className={styles.wrapper}>
			<span className={styles.currency}>{currencyString}</span>
			<BaseInput
				errorMessage={fieldState.error?.message}
				isInvalid={fieldState.invalid}
				{...props}
				className={styles.amount}
				formatOptions={{ minimumFractionDigits: 2, useGrouping: true }}
				onChange={(val) => {
					field.onChange(val);
					props.onChange?.(val);
				}}
				type="number"
				value={field.value as number}
			/>
		</div>
	);
}
